import Button from "../../../../componentes/button/button";
import StagedAnexosEditor from "../../Anexos/StagedAnexosEditor";
import ComentariosStagedEditor from "../../Comentarios/ComentariosStagedEditor";

// Layout padrão das telas de criação de solicitação: os campos do processo ocupam 3/4 da
// largura, enquanto anexos e comentários ficam fixos numa coluna lateral de 1/4.
export default function NovaSolicitacaoLayout({ anexos, onAnexosChange, comentarios, onComentariosChange, etapaInicialExigeAnexo, children, sugestoes, rateioItens, rateioItensDetalhados, formaPagamento, anexosExtras, onRemoverAnexoExtra, anexosObrigatorios = [] }) {
    const anexoObrigatorio = etapaInicialExigeAnexo || anexosObrigatorios.length > 0;
    return (
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 items-start">
            <div className="bg-card border border-border rounded-lg shadow-card p-4 md:p-6 lg:col-span-3 flex flex-col gap-4">
                {children}
            </div>

            <div className="bg-card border border-border rounded-lg shadow-card p-4 md:p-6 lg:col-span-1 flex flex-col gap-4 lg:sticky lg:top-4 lg:self-start lg:max-h-[calc(100vh-2rem)] lg:overflow-y-auto">
                <div>
                    <label className="text-sm font-medium text-foreground/80 block mb-2">
                        Anexos {anexoObrigatorio && <span className="text-destructive">*</span>}
                    </label>
                    <StagedAnexosEditor
                        itens={anexos}
                        onChange={onAnexosChange}
                        obrigatorio={anexoObrigatorio}
                        sugestoes={sugestoes}
                        rateioItens={rateioItens}
                        rateioItensDetalhados={rateioItensDetalhados}
                        formaPagamento={formaPagamento}
                        itensExtras={anexosExtras}
                        onRemoverExtra={onRemoverAnexoExtra}
                        anexosObrigatorios={anexosObrigatorios}
                    />
                </div>

                <div>
                    <label className="text-sm font-medium text-foreground/80 block mb-2">Comentários</label>
                    <ComentariosStagedEditor itens={comentarios} onChange={onComentariosChange} />
                </div>
            </div>
        </div>
    );
}
